import i18next from 'i18next';

import { getClientStoreNameTranslation } from '../../../utils/translations';

export const DETAILS = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('ADMIN.SUB_FEATURES.INFORMATIONS'),
  path: '/admin/stores/:id/details',
  getLink: ({ storeId }) => `/admin/stores/${storeId}/details`,
};

export const MAPPED_USERS = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('ADMIN.SUB_FEATURES.MAPPED_USERS'),
  path: '/admin/stores/:id/details-users',
  getLink: ({ storeId }) => `/admin/stores/${storeId}/details-users`,
};

export const PRODUCTION_SCHEDULE = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('ADMIN.SUB_FEATURES.PRODUCTION_ASSORTMENTS'),
  path: '/admin/stores/:id/products',
  getLink: ({ storeId }) => `/admin/stores/${storeId}/products`,
};

export const TIME_SLOTS = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('ADMIN.SUB_FEATURES.TIME_SLOTS'),
  path: '/admin/stores/:id/time-slots',
  getLink: ({ storeId }) => `/admin/stores/${storeId}/time-slots`,
  isVisible: ({ isKitchen }) => !isKitchen,
};

export const SUPPLIER_PROFILES = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('ADMIN.SUB_FEATURES.MAPPED_SUPPLIER_PROFILES'),
  path: '/admin/stores/:id/supplierProfiles',
  getLink: ({ storeId }) => `/admin/stores/${storeId}/supplierProfiles`,
};

export const BUFFER_STOCKS = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('ADMIN.SUB_FEATURES.ASSOCIATED_INGREDIENTS'),
  path: '/admin/stores/:id/buffer-stocks',
  getLink: ({ storeId }) => `/admin/stores/${storeId}/buffer-stocks`,
};

export const INTEGRATIONS = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('FEATURE_NAME_ADMIN_INTEGRATIONS'),
  path: '/admin/stores/:id/integrations',
  getLink: ({ storeId }) => `/admin/stores/${storeId}/integrations`,
};

export const SUPPLIER_PRODUCTS = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('ADMIN.SUB_FEATURES.MAPPED_SUPPLIER_PRODUCTS'),
  path: '/admin/stores/:id/supplier-products',
  getLink: ({ storeId }) => `/admin/stores/${storeId}/supplier-products`,
};

export const CENTRAL_PRODUCTS = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('ADMIN.SUB_FEATURES.CENTRAL_PRODUCTS'),
  path: '/admin/stores/:id/central-products',
  getLink: ({ storeId }) => `/admin/stores/${storeId}/central-products`,
  isVisible: ({ isKitchen }) => !!isKitchen,
};

export const BACKOFFICE_STORE_DETAILS = {
  getText: ({ storeName }) => getClientStoreNameTranslation(storeName),
  path: '/backoffice/stores/stores/:id/details',
  getLink: ({ storeId }) => `/backoffice/stores/stores/${storeId}/details`,
  isVisible: () => false,
};

export const BACKOFFICE_STORE_CREATION = {
  getText: ({ storeName }) => i18next.t('BACKOFFICE.STORES.CREATION_MODAL_TITLE', { storeName }),
  path: '/backoffice/stores/stores/create/details',
  isVisible: () => false,
};

export const BACKOFFICE_CASHIER_STORE_DETAILS = {
  getText: () => i18next.t('BACKOFFICE.DATA.EXPORT_PRODUCT_SALES_HEADER_CASHIER_STORE'),
  path: '/backoffice/stores/cashier-stores/:id/details',
  isVisible: () => false,
};
